import PropTypes from 'prop-types';
import NgpTextarea from '../../form/NgpTextarea';
import { DESCRIPTION_FIELD, LABEL_DESCRIPTION, LABEL_POLLING_STATUS, UISTATE_FIELD } from './InfrastructureConstants';
import { FIELD_CONSTRAINTS } from './FieldConstraints';
import NgpTextField from '../../form/NgpTextField';

const DESCRIPTION_MAX_LENGTH = FIELD_CONSTRAINTS.DESCRIPTION.maxLength;
const DESCRIPTION_COLS = FIELD_CONSTRAINTS.DESCRIPTION.cols;

/**
 * Renders polling status select field (read-only)
 * Shows current monitoring status of the infrastructure entity
 */
export const PollingStatusField = () => {
    return <NgpTextField fieldName={UISTATE_FIELD} label={LABEL_POLLING_STATUS} disabled />;
};

/**
 * Renders description textarea field
 * Provides multi-line text input for entity descriptions
 * @param {Object} props - Component props
 * @param {number} props.cols - Number of columns (default: 60)
 * @param {number} props.maxLength - Maximum character length (default: 225)
 * @param {boolean} props.required - Whether field is required
 */
export const DescriptionField = ({
    cols = DESCRIPTION_COLS,
    maxLength = DESCRIPTION_MAX_LENGTH,
    required = false,
    fieldName = DESCRIPTION_FIELD,
}) => {
    return (
        <NgpTextarea
            fieldName={fieldName}
            label={LABEL_DESCRIPTION}
            cols={cols}
            inputProps={{ maxLength }}
            required={required}
        />
    );
};

DescriptionField.propTypes = {
    cols: PropTypes.number,
    maxLength: PropTypes.number,
    required: PropTypes.bool,
    fieldName: PropTypes.string,
};

DescriptionField.defaultProps = {
    cols: DESCRIPTION_COLS,
    maxLength: DESCRIPTION_MAX_LENGTH,
    required: false,
    fieldName: DESCRIPTION_FIELD,
};
